import { render, staticRenderFns } from "./carMonthChargeV1.vue?vue&type=template&id=28546624&scoped=true&"
import script from "./carMonthChargeV1.vue?vue&type=script&lang=js&"
export * from "./carMonthChargeV1.vue?vue&type=script&lang=js&"
import style0 from "./carMonthChargeV1.vue?vue&type=style&index=0&id=28546624&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28546624",
  null
  
)

export default component.exports